/**
 * BUG-2026-0136 / BUG-2026-0135: surface the backend's error text (e.g. 403
 * "Insufficient permissions to create clients") instead of a generic
 * "Failed to …" message, so the user learns WHY the action was refused.
 *
 * Shared by the quote editor's pricing section and quick-add dialogs — add new
 * catch-blocks here rather than re-declaring the extraction per component.
 */
export const apiErrorText = (err: unknown, fallback: string): string => {
  const apiMsg = typeof err === 'object' && err !== null
    ? (err as { response?: { data?: { error?: string } } }).response?.data?.error
    : undefined;
  return apiMsg ?? (err instanceof Error && err.message ? err.message : fallback);
};

/** HTTP status of an axios-style error, when present (e.g. 403). */
export const apiErrorStatus = (err: unknown): number | undefined =>
  typeof err === 'object' && err !== null
    ? (err as { response?: { status?: number } }).response?.status
    : undefined;
